/**
 * @class PolygridItem
 */

import React from 'react'

const PolygridItem = props =>
  <div {...props} style={{ width: '100%', height: '100%' }} />

export default PolygridItem
